<template>
  <div class="fill-height">
    <router-view v-if="$route.name.includes('Show')"/>
    <TemplatePageGrid
      v-else-if="employeeSalaryPeriodGrid[0]"
      :items="employeeSalaryPeriodGrid"
      :page-data="pageData"
      :loading="loadingAnimation"
    >
      <FinanceSalarySliceTable>
        <FinanceSalarySliceTableItem
          v-for="(item, i) in employeeSalaryPeriodGrid"
          :key="i"
          :item="item"
        />
      </FinanceSalarySliceTable>
    </TemplatePageGrid>
    <Plug v-else />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import TemplatePageGrid from "../../../components/templates/TemplatePageGrid";
import FinanceSalarySliceTable from "../../../components/finance/salary/FinanceSalarySliceTable";
import FinanceSalarySliceTableItem from "../../../components/finance/salary/FinanceSalarySliceTableItem";
import Plug from "../../../components/Plug";

export default {
  name: "salarySlice",
  components: {Plug, FinanceSalarySliceTableItem, FinanceSalarySliceTable, TemplatePageGrid},
  computed: {
    ...mapGetters(['loadingAnimation']),
    ...mapGetters('employeeSalaryPeriod', ['employeeSalaryPeriodGrid', 'pageData']),
  },
  created() {
    this.onDownloadPageData()
  },
  watch: {
    '$route.query'() {
      this.onDownloadPageData()
    },
  },
  methods: {
    ...mapActions('employeeSalaryPeriod', ['onEmployeeSalaryPeriodGrid']),
    ...mapMutations(['setLoadingAnimation']),
    async onDownloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      if (!this.$route.name.includes('Show'))
      await this.onEmployeeSalaryPeriodGrid(data)
      this.setLoadingAnimation(false)
    }
  }
}
</script>
